import React from 'react';
import {connect} from "react-redux";
import {makeStyles} from '@material-ui/core/styles';
import {blue} from '@material-ui/core/colors';
import {Link} from "react-router-dom";
import {addFavorite} from "../../actions/updateFirestoreData/userData/addFavorite";
import {removeFavorite} from "../../actions/updateFirestoreData/userData/removeFavorite";
import {getDate} from "../../actions/calcul/getDate";
import {numAverage} from "../../actions/calcul/average";import Typography from '@material-ui/core/Typography';
import {Grid, CardHeader, CardContent, Card,Paper, IconButton, LinearProgress} from "@material-ui/core";
import {RateIcon} from "../mui/RateIcon";
import FavoriteBorderIcon from "@material-ui/icons/FavoriteBorder";
import FavoritePic from '@material-ui/icons/Favorite';
import ExpansionPan from "../mui/ExpansionPan";


const useStyles = makeStyles((theme) => ({
    root: {
        maxWidth: "45%",
        margin: 10
    },
    expansion: {
        width: '100%',
    },
    expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    comment: {
        backgroundColor: blue[50],
        margin: 2,
        padding: 5,
    },
    margin: {
        margin: 5
    },
    info: {
        width: "350"
    },
    details: {
        padding: 5,
    },
    timing: {
        fontSize: 12,
        width: "45%"
    },
    title: {
        width: "45%"
    }
}));


/**
 * This will be a card containing dish's data like name, a picture, comments, ingredients and description.
 * more complete than recipeCard
 * @param recipe            {Object}:   recipe's information that will be displayed
 * @param auth              {Object}:   user's data
 * @param removeFavorite    {function}: function to remove a recipe from favorites
 * @param addFavorite       {function}: function to add a recipe in favorites
 * @param favorites         {array}:    contains user's favorites recipes
 * @return {*}
 * @constructor
 */
const Recipe = ({recipe, auth, removeFavorite, addFavorite, favorites}) => {

    const classes = useStyles();
    const [isFavorite, setFavorite] = React.useState(favorites.includes(recipe.id) ? true : false);
    const [isLoading, setLoading] = React.useState(true);
    let ingredientsName = Object.keys(recipe.ingredients_quantity);
    let ingredientsQuantity = Object.values(recipe.ingredients_quantity);
    let recipeIngredients = [];
    for (let i = 0; i < ingredientsName.length; i++) {
        recipeIngredients.push({name: ingredientsName[i], quantity: ingredientsQuantity[i]});
    }

    const addToFavorite = async (e) => {
        e.preventDefault();
        setFavorite(true);
        await addFavorite({recipe: recipe, userPseudo: auth.pseudo});
    };

    const removeToFavorite = async (e) => {
        e.preventDefault();
        //setLoading(true);
        setFavorite(false);
        setLoading(false);
        await removeFavorite(recipe, auth);
    };

    React.useEffect(() => {
            if (favorites.find(element => element.id === recipe.id)) {
                setFavorite(true);
            }
            setLoading(false);
        }, []
    );

    //if we delete if(isLoading) {return <LinearProgress/>}; we can display recipe
    if (isLoading) {
        return <LinearProgress/>
    }
    return (
        <>
            <Link to={{pathname: `/recettes/${recipe.id}`}} style={{margin: 'auto', width: '100%'}}>
                <div align='center' style={{width: 'auto', borderRadius: 10}}>
                    <img style={{width: '100%', height: '100%', borderRadius: 5}} src={recipe.image} alt={recipe.name}/>
                </div>
            </Link>
            <Paper className={classes.info}>
                <Typography
                    align='center'>{recipe.name}</Typography>
                <Typography>{recipe.timming}</Typography>

                {
                    recipe.ingredients ?
                        <ExpansionPan  title="Ingrédients"
                            content={<Grid>
                                {recipeIngredients.map((ingredient, index2) =>
                                    <Typography key={index2}
                                                paragraph>{ingredient.quantity} {ingredient.name}
                                    </Typography>
                                )}
                            </Grid>}/>
                        : ""
                }
                {
                    recipe.comments ?
                        <ExpansionPan  title="Commentaires"
                                       content={<Grid container direction="column" justify="center" style={{color: 'black'}}>
                                           {recipe.comments.slice(0, 3) ? recipe.comments.slice(0, 3).map((comment, index3) =>
                                               <Card key={index3} style={{background: 'rgb(200, 200, 200)'}} className={classes.comment}>
                                                   <CardHeader
                                                       title={comment.user}
                                                       subheader={getDate(comment.date.seconds)}
                                                   />
                                                   <CardContent>
                                                       <Typography paragraph> {comment.text} </Typography>
                                                   </CardContent>
                                               </Card>
                                           ) : ""}
                                       </Grid>}/>
                        : ""
                }


                <Grid container direction="row" justify="space-between" alignItems="center">
                    {auth ?
                        <Grid item>
                            <IconButton type='button' onClick={isFavorite ? removeToFavorite : addToFavorite}>
                                {isFavorite ? <FavoritePic style={{color: '#f44336'}}/> : <FavoriteBorderIcon/>}
                            </IconButton>
                        </Grid>
                        : null
                    }
                    <Grid item style={{color: '#f44336'}}>
                        <RateIcon rateValue={recipe.ratings ? numAverage(recipe.ratings) : 0}/>
                    </Grid>
                </Grid>
            </Paper>
        </>
    );
};


export default connect(
    null,
    {addFavorite, removeFavorite, getDate}
)(Recipe)
